import { Edit } from '@mui/icons-material';
import { Card, CardContent, CardHeader, IconButton } from '@mui/material';
import { FC, useCallback } from 'react';
import {
  FieldProps,
  Link,
  Loading,
  useShowController,
  useRecordContext,
} from 'react-admin';
import { useNavigate } from 'react-router-dom';

export const ExtensionField = (props: FieldProps) => {
  const value = useRecordContext(props);
  const { extension } = value;
  if (String(extension) === 'pdf') {
    return <span>Инструкция</span>;
  }
  return <span>Характеристики</span>;
};

export const LinkFileEditField = (props: FieldProps) => {
  const value = useRecordContext(props);
  const { id } = value;
  console.log(id);
  let link = '/files/' + String(id);
  return <Link to={link}>Редактировать</Link>;
};

export const JivoChatShow: FC = () => {
  const data = useShowController();
  const navigate = useNavigate();
  const { record: { id } = {}, isLoading, isFetching } = data;

  const handleClickEdit = useCallback(() => {
    navigate(`/jivo_chats/${id}`);
  }, [id, navigate]);

  if (isLoading || isFetching) {
    return <Loading />;
  }
  const list: any[] = [];
  if (data.record.files) {
    data.record.files.forEach((file: any) => {
      list.push(<li>{file.original_name}</li>);
    });
  }
  // let filter = {
  //   files: data.record.files,
  // };
  // let is_active_text: string = 'Не активно';
  // if (data.record.is_active) {
  //   is_active_text = 'Активно';
  // }
  return (
    <Card>
      <CardHeader
        title={`${data.record.name}`}
        subheader={data.record.article}
        action={
          <IconButton aria-label="Edit" onClick={handleClickEdit}>
            <Edit />
          </IconButton>
        }
      />
      <CardContent>
        <b>Артикуль: </b>
        {data.record.id}
        <br />
        <b>Имя: </b>
        {data.record.name}
        <br />
        <b>Provider id для чата: </b>
        {data.record.provider_id}
        <br />
        <b>Токен: </b>
        {data.record.token}
        <br />
        <b>Стартовое сообщение: </b>
        {data.record.start_message}
        <br />
      </CardContent>
    </Card>
  );
};
